import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper/";
import media from "styled-media-query";
import { H3 } from "BaseComponents/Text";
import { Paragraph } from "BaseComponents/Text";
import { StyledBackgroundImage } from "../../../framework/lazy/StyledBgImage";

export const SearchTopWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.bg1};
  width: 100%;
`;

export const SearchTop = styled.div`
  margin: 0 auto;
  max-width: 940px;
  padding: 3rem 1rem;

  ${media.greaterThan(breakpoints.ipad)`
        padding: 5rem 0;
    `}
`;

export const SearchInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 2rem 0 0 0;
`;

export const HitsWrapper = styled.div.attrs(({ flex, showPriority }) => {})`
  max-width: 1170px;
  padding: 1rem;
  margin: 2rem auto;
  display: ${({ flex }) => (flex ? "flex" : "block")};
  gap: ${({ flex }) => (flex ? "15px" : "0px")};
  flex-direction: column;

  ${({ flex }) =>
    flex &&
    css`
      margin-top: 0;
      padding-top: 0;
      & > div {
        flex-basis: 100%;
      }
    `}

  ${media.greaterThan(breakpoints.ipad)`
        flex-direction: row;
        
        ${({ flex }) =>
          flex &&
          css`
            flex-wrap: wrap;
            & > div {
              flex-basis: calc(100% / 3 - (15px * 2 / 3));
              ${({ showPriority }) =>
                showPriority &&
                css`
                  :first-child {
                    flex-basis: 100%;
                  }
                `}
            }
          `}
  `}
`;

export const HitsCategoriesWrapper = styled.div`
  display: flex;
  gap: 24px;
`;

export const HitsCategoryItem = styled.div`
  cursor: pointer;
`;

export const HitsCountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 1170px;
  padding: 1rem;
  margin: 0 auto;
  ${media.greaterThan(breakpoints.ipad)`
    align-items: flex-start;
  `}
`;

export const SearchWrapper = styled.div``;

export const HitWrapper = styled.a`
  ${H3} span {
    transition: 0.2s ease;
    border-bottom: 2px solid transparent;
  }
  &:hover {
    ${H3} span {
      transition: 0.2s ease;
      border-color: black;
    }
  }
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  cursor: pointer;

  ${({ isLoaded }) =>
    isLoaded &&
    `
        opacity: 1;
        transform: translateY(0);
    `}

  ${media.greaterThan(breakpoints.ipad)`
        flex-direction: row;
        min-height: 164px;
  `}

 

	&:hover,
	&:focus {
    ${StyledBackgroundImage} {
      opacity: 0.7;
    }
  }
`;

export const HitWithCategoryWrapper = styled.a.attrs(
  ({ flex, showPriority, isFirst }) => {}
)`
  ${H3} span {
    transition: 0.2s ease;
    border-bottom: 2px solid transparent;
  }
  &:hover {
    ${H3} span {
      transition: 0.2s ease;
      border-color: black;
    }
  }
  display: flex;
  flex-direction: column;
  cursor: pointer;

  ${({ isLoaded }) =>
    isLoaded &&
    `
        opacity: 1;
        transform: translateY(0);
    `}

  ${media.greaterThan(breakpoints.ipad)`
        min-height: 164px;
        ${({ flex }) =>
          flex &&
          css`
            height: 100%;
            ${({ isFirst }) =>
              isFirst &&
              css`
                flex-direction: row;
              `}
          `}
  `}

	&:hover,
	&:focus {
    ${StyledBackgroundImage} {
      opacity: 0.7;
    }
  }
`;

export const HitImageWrapper = styled.div.attrs(({ flex, isFirst }) => {})`
  flex-basis: 26%;
  flex-grow: 1;
  position: relative;
  min-height: 194px;
  ${StyledBackgroundImage} {
    border-radius: ${({ theme }) =>
      `${theme.border.radius} 0 0 ${theme.border.radius} `};
    ${media.lessThan(breakpoints.mobile)`
		border-radius: ${({ theme }) =>
      ` ${theme.border.radius} ${theme.border.radius} 0 0`};
		`}
  }

  ${media.greaterThan(breakpoints.ipad)`
        flex-grow: 0;
        min-height: auto;
        ${({ flex, isFirst }) =>
          flex &&
          isFirst &&
          css`
            flex-basis: calc(100% + 2px);
          `}
  `}
`;

export const HitTextWrapper = styled.div.attrs(({ flex, isFirst }) => {})`
  flex-basis: 60%;
  border-radius: ${({ theme }) =>
    `0 ${theme.border.radius}  ${theme.border.radius} 0`};
  ${media.lessThan(breakpoints.mobile)`
		border-radius: ${({ theme }) =>
      `0 0 ${theme.border.radius} ${theme.border.radius}`};

	`}
  flex-grow: 1;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  padding: 1rem;

  ${media.greaterThan(breakpoints.ipad)`
        padding: .5rem 1rem;
        ${({ flex, isFirst }) =>
          flex &&
          isFirst &&
          css`
            flex-basis: calc(50% - 2px);
          `}
    `}
`;

export const HitMetaDataWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HitCategory = styled(Paragraph)`
  & {
    margin: 0;
    font-size: 14px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.black};
    &:before {
      content: "";
      display: inline-block;
      width: 8.7px;
      height: 8.7px;
      background-color: ${({ beforeColor, theme }) =>
        beforeColor ? beforeColor : theme.colors.secondary};
      margin: 0 5px 0 0;
    }
  }
`;

export const NoHitsTextParagraph = styled(Paragraph)`
  & {
    font-size: 18px;
    max-width: 940px;
    margin: 0 auto;
    display: block;
  }
`;
